// Full Sun Graphics redesign — section behaviour (tabs, AJAX add-to-cart wired to the theme's cart drawer, hero sun rays)
import { CartAddEvent } from '@theme/events';

function initRays(root = document) {
  root.querySelectorAll('[data-fsg-rays]').forEach((g) => {
    if (g.childElementCount) return;
    let html = '';
    for (let i = 0; i < 24; i++) {
      const long = i % 2 === 0;
      html += `<path d="M196 ${long ? 8 : 34}h8l-4 52z" transform="rotate(${i * 15} 200 200)" fill="var(--fsg-gold)" opacity="${long ? 0.9 : 0.55}"/>`;
    }
    g.innerHTML = html;
  });
}

function initShelf(root = document) {
  root.querySelectorAll('[data-fsg-shelf]').forEach((shelf) => {
    if (shelf.dataset.ready) return;
    shelf.dataset.ready = '1';
    const tabs = [...shelf.querySelectorAll('[data-fsg-tab]')];
    const panels = [...shelf.querySelectorAll('[data-fsg-panel]')];
    const select = (id) => {
      tabs.forEach((t) => t.setAttribute('aria-selected', String(t.dataset.fsgTab === id)));
      panels.forEach((p) => (p.hidden = p.dataset.fsgPanel !== id));
      const tab = tabs.find((t) => t.dataset.fsgTab === id);
      if (!tab) return;
      shelf.style.setProperty('--fsg-world-bg', tab.dataset.bg);
      shelf.style.setProperty('--fsg-world-accent', tab.dataset.accent);
      const eb = shelf.querySelector('[data-fsg-eyebrow]');
      const ti = shelf.querySelector('[data-fsg-title]');
      if (eb) eb.textContent = tab.dataset.eyebrow;
      if (ti) ti.textContent = tab.dataset.title;
    };
    tabs.forEach((t) => t.addEventListener('click', () => select(t.dataset.fsgTab)));
    shelf.querySelector('[role="tablist"]')?.addEventListener('keydown', (e) => {
      if (!['ArrowLeft', 'ArrowRight'].includes(e.key)) return;
      const i = tabs.indexOf(document.activeElement);
      const n = tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
      n.focus();
      select(n.dataset.fsgTab);
    });
    // deep links like #fsg-world-garage
    const hash = location.hash.replace('#fsg-world-', '');
    if (tabs.some((t) => t.dataset.fsgTab === hash)) select(hash);
    else if (tabs[0]) select(tabs[0].dataset.fsgTab);
  });
}

document.addEventListener('submit', async (e) => {
  const form = e.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('[data-fsg-add]')) return;
  e.preventDefault();
  const btn = form.querySelector('button[type="submit"]');
  const label = btn ? btn.textContent : '';
  if (btn) { btn.disabled = true; btn.textContent = btn.dataset.adding || 'Adding…'; }
  try {
    const fd = new FormData(form);
    const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
      method: 'POST', headers: { Accept: 'application/json' }, body: fd,
    });
    if (!res.ok) throw new Error((await res.json()).description || 'Could not add to cart');
    const cart = await (await fetch((window.Shopify?.routes?.root || '/') + 'cart.js')).json();
    document.dispatchEvent(new CartAddEvent(cart, 'fsg-shelf', {
      source: 'fsg-shelf', itemCount: cart.item_count, variantId: String(fd.get('id')),
    }));
    if (btn) btn.textContent = btn.dataset.added || 'Added ✓';
  } catch (err) {
    if (btn) btn.textContent = btn.dataset.error || 'Try again';
    console.warn('[fsg] add to cart failed', err);
  } finally {
    setTimeout(() => { if (btn) { btn.disabled = false; btn.textContent = label; } }, 1600);
  }
});

const init = (root) => { initRays(root); initShelf(root); };
init();
document.addEventListener('shopify:section:load', (e) => init(e.target));
document.addEventListener('shopify:block:select', (e) => {
  const tab = e.target.closest?.('[data-fsg-tab]');
  if (tab) tab.click();
});
